import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from "@angular/common/http";
import {NotificationsService} from "angular2-notifications";
import {saveAs} from 'file-saver';
import {Router} from "@angular/router";
import {
  AgGridUtility,
  AUDIT_ENTITY_COLUMN_DEFS,
  AUDIT_ENTITY_ID,
  AUDIT_ENTITY_TYPE,
  AUDIT_PAGE_TITLE,
  CommonUtility,
  DataService,
  DateUtility,
  EDIT_BTN,
  ServerConstantsService,
  SINGLE_ROW_HEADER,
  Task,
  TimeUtility,
  WpPerson,
  WpProvider
} from "../shared";
import {ReferenceTableService} from "../reference-table.service";
import {ProviderDashboardSearch} from "../shared/model/ProviderDashboardSearch";
import {TaskChart} from "../shared/model/TaskChart";
import {ProviderService} from '../provider-management/provider-management.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LoaderComponent} from '../loader/loader.component';
import * as $ from 'jquery';

@Component({
  selector: 'app-worker-dashboard',
  templateUrl: './worker-dashboard.component.html',
  styleUrls: ['./worker-dashboard.component.scss']
})
export class WorkerDashboardComponent implements OnInit {

  tabToNextCell:any;
  gridApi: any;
  gridAnnouncementsApi: any;
  ServerConstants: any;
  dashboardSearchRequest : ProviderDashboardSearch;
  dashboardSearchResponse: ProviderDashboardSearch;

  countyCds: Array<any>;

  taskCounty: Array<any>;
  countiesSelect: Array<any>;
  taskStatus: any[];
  priorities: any[];
  taskType: any[];
  taskTypes: any[];
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;
  countyMap: Map<string, string>;
  taskStatusMap: any;
  taskTypeMap: any;
  prioritiesMap: any;
  taskTypesMap: any;
  taskStatusJson: any;
  prioritiesJson: any;
  taskTypesJson: any;

  isAlreadyLoaded: boolean;
  userActionNotificationsMap: any;


  /********* Task Chart **********/
  noPendingTasks = 0;
  noOverdueTasks = 0;
  noUpcomingTasks = 0;
  maxValue: number;

  taskChartDateTomorrow?: any;
  taskChartDateTomorrowPlus30?: any;
  taskChartDateYesterday?: any;
  numberTaskChartBefore: number;
  numberTaskChartDaysAfter: number;

  chartTaskOptions = {
    legend: {
      position: 'bottom',
    },
    responsive: true,
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Date'
        }
      }],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'No. of Tasks'
          },
          ticks: {
            beginAtZero: true,
            //scaleOverride : true,
            //suggestedMin: 10,
            max: this.maxValue,
            //suggestedMin: 10,
            stepSize: 2,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            },
          }
        }
      ]
    }
  };

  chartTaskData = [
    { data: [], label: 'Due Today' },
    { data: [], label: 'Upcoming' },
    { data: [], label: 'Overdue' }
  ];

  chartTaskLabels = [];

  public lineTaskChartColors:Array<any> = [
    { // orange
      backgroundColor: 'rgba(231,105,29,1)',
      borderColor: 'rgba(231,105,29,1)',
      pointBackgroundColor: 'rgba(231,105,29,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(231,105,29,1)'
    },
    { // blue
      backgroundColor: 'rgba(65,105,225,1)',
      borderColor: 'rgba(65,105,225,1)',
      pointBackgroundColor: 'rgba(65,105,225,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(65,105,225,1)'
    },
    { // red
      backgroundColor: 'rgba(197,36,61,1)',
      borderColor: 'rgba(197,36,61,1.00)',
      pointBackgroundColor: 'rgba(197,36,61,1.00)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(197,36,61,1.00)'
    }
  ];

  public lineAppChartColors:Array<any> = [
    { // blue
      backgroundColor: 'rgba(65,105,225,0.2)',
      borderColor: 'rgba(65,105,225,1)',
      pointBackgroundColor: 'rgba(65,105,225,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(65,105,225,1)'
    }
  ];

  /*Grid Table*/
  columnDefs: any;
  columnDefsTask: any;
  context: any;
  auditColumnDefs: any;

  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;

  constructor(
    private http: HttpClient,
    private dataService: DataService,
    private router: Router,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private timeUtil: TimeUtility,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private dateUtil: DateUtility,
    private dateTimeUtil: TimeUtility,
    private agGridUtility: AgGridUtility,
    private providerService: ProviderService,
    private modalService: NgbModal
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
  }
   @ViewChild('all1') all1: ElementRef;
   ws: any;
  ngOnInit() {
    console.log("inside  dashboard/worker");

    this.http.get<any>(this.ServerConstants.SERVER_API_URL + '/userinfo').subscribe(
      data => {
        var isProviderRole = false;
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            console.log('role worker dashboard: : ' + data.roles[0].id);
            if(data.roles[0].id == 5){  
              isProviderRole=true;              
              break;
            }
          }}

          if(isProviderRole){
            console.log('Redirecting to provider dashboard');
            this.router.navigate(['dashboard']);
          } else {
            this.dashboardSearchRequest = new ProviderDashboardSearch();
            this.dashboardSearchRequest.taskChart = new TaskChart();
        
            this.dashboardSearchRequest.taskChart.taskCounty = "-1";
        
            this.dashboardSearchResponse = new ProviderDashboardSearch();
            this.dashboardSearchResponse.announcements = [];
            this.dashboardSearchResponse.workerTasks = [];
        
            this.isAlreadyLoaded = false;
        
            this.countiesSelect = [];
        
            this.parseRefTableData();
            //this.dashboardSearchRequest.todayDateTime = new Date();
        
            this.setTasksChart();
            this.setAnnouncements();
            this.formatDates();
            this.getColumnDefinitions();
            this.getAuditColumnDefs();
            this.loadProviders();
          }      
  
}, response => {
console.log('error', response);
if(response.status === 401){
this.router.navigate(['dashboard']);
}
}, () => {

});
  }

  formatDates(){
    this.dashboardSearchRequest.todayDate = new Date();
    this.dashboardSearchRequest.todayDate = this.dateUtil.convertObjectDateForServer(
      this.dashboardSearchRequest.todayDate);

    /*task*/
    this.dashboardSearchRequest.taskChart.todayDate = this.dateUtil.convertObjectDateForServer(
      this.dashboardSearchRequest.taskChart.todayDate);
    /*this.dashboardSearchRequest.taskChart.taskChartDateFrom = this.dateUtil.convertObjectDateForServer(
      this.dashboardSearchRequest.taskChart.taskChartDateFrom);*/
    this.dashboardSearchRequest.taskChart.taskChartDateTo = this.dateUtil.convertObjectDateForServer(
      this.dashboardSearchRequest.taskChart.taskChartDateTo);
  }

  setTasksChart(){
    this.numberTaskChartBefore = 5;
    this.numberTaskChartDaysAfter = 5;
    this.dashboardSearchRequest.taskChart.todayDate = new Date();
    this.dashboardSearchRequest.taskChart.taskChartDateFrom = new Date();
    /*this.dashboardSearchRequest.taskChart.taskChartDateFrom.setDate(this.dashboardSearchRequest.taskChart.taskChartDateFrom.getDate()
      - this.numberTaskChartBefore);
      console.log(this.dashboardSearchRequest.taskChart.taskChartDateFrom.getDate()
      - this.numberTaskChartBefore);*/
      this.dashboardSearchRequest.taskChart.taskChartDateFrom = "2000/08/01";
    this.dashboardSearchRequest.taskChart.taskChartDateTo = new Date();
    this.dashboardSearchRequest.taskChart.taskChartDateTo.setDate(this.dashboardSearchRequest.taskChart.taskChartDateTo.getDate()
      + this.numberTaskChartDaysAfter);

    this.taskChartDateTomorrow = new Date();
    this.taskChartDateTomorrow.setDate ( this.taskChartDateTomorrow.getDate() + 1) ;

    this.taskChartDateTomorrowPlus30 = new Date();
    this.taskChartDateTomorrowPlus30.setDate ( this.taskChartDateTomorrowPlus30.getDate() + 30 );

    this.taskChartDateYesterday = new Date();
    this.taskChartDateYesterday.setDate(  this.taskChartDateYesterday.getDate() -1 );

  }

  setAnnouncements() {}


  searchWorkerDashboard() {
    setTimeout(() => this.modalService.open(LoaderComponent, {
      centered: true,
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
      backdropClass: 'loaderBackdrop',
      windowClass: '2'
    }), 0); 

    this.http.post<ProviderDashboardSearch> (this.ServerConstants.SERVER_API_URL + "/dashboard/taskStats", this.dashboardSearchRequest ).subscribe((data)=>{
      if(data.hasOwnProperty('errorCode')){
        this.notificationService.error('Dashboard', this.userActionNotificationsMap.ERROR);
      }
      else{
        this.dashboardSearchResponse = data;
        if(!this.isAlreadyLoaded){
          if( this.dashboardSearchResponse.counties != null || this.dashboardSearchResponse.counties != undefined){
            let countiesArray= this.dashboardSearchResponse.counties.split(',');
            for(let count=0; count< countiesArray.length; count++ ){
              this.countiesSelect.push({ value: countiesArray[count], name: this.convertCode( this.countyMap , countiesArray[count] + '' )} );
            }
            this.countiesSelect.sort(this.commonUtil.sortObjectsByProperty('name'));
            this.countiesSelect.unshift( { value: '-1', name: 'Pick an Option' });
            this.isAlreadyLoaded = true;
          }
        }
        this.updateTaskDataChart(this.dashboardSearchResponse.taskChart.pendingTaskChartYData.slice(Math.max(this.dashboardSearchResponse.taskChart.pendingTaskChartYData.length - 11, 1)),
        this.dashboardSearchResponse.taskChart.upcomingTaskChartYData.slice(Math.max(this.dashboardSearchResponse.taskChart.upcomingTaskChartYData.length - 11, 1)),
        this.dashboardSearchResponse.taskChart.overdueTaskChartYData.slice(Math.max(this.dashboardSearchResponse.taskChart.overdueTaskChartYData.length - 11, 1)),
        this.dashboardSearchResponse.taskChart.taskChartXData.slice(Math.max(this.dashboardSearchResponse.taskChart.taskChartXData.length - 11, 1)),this.dashboardSearchResponse.taskChart.overdueTaskChart);

        this.dashboardSearchResponse.taskChart.todayDate = new Date();
      }
      this.loadAnnouncements();
    },
    response => {
      this.notificationService.error('Dashboard', this.userActionNotificationsMap.ERROR);
    },
    () => {
    });
  }

  
  loadAnnouncements(){
    this.http.post<ProviderDashboardSearch> (this.ServerConstants.SERVER_API_URL + "/dashboard/announcements", this.dashboardSearchRequest ).subscribe((data)=>{
      this.dashboardSearchResponse.announcements = data.announcements;
    },
    response => {
      this.notificationService.error('Dashboard', this.userActionNotificationsMap.ERROR);
    },
    () => {
    });
    this.laodtaskList();
  }
  laodtaskList(){
    this.http.post<ProviderDashboardSearch> (this.ServerConstants.SERVER_API_URL + "/dashboard/taskList", this.dashboardSearchRequest ).subscribe((data)=>{
      this.dashboardSearchResponse.workerTasks = data.workerTasks;
      setTimeout(() => {
        $('ngb-modal-window.2:visible').remove();
        $('ngb-modal-backdrop:visible').remove();
      }, 0);
    },
    response => {
      this.notificationService.error('Dashboard', this.userActionNotificationsMap.ERROR);
    },
    () => {
    });
  }

  getColumnDefinitions() {

    this.columnDefsTask = [
      { headerName: 'Task ID',
        field: 'id',
        cellRenderer: this.getTaskIdLink,
        //cellStyle: {'text-align': 'right !important'},
        width: 100,
      },
      { headerName: 'Task Type',
        field: 'taskType',
        refData: this.taskTypesJson,
        cellRenderer: this.getTaskTypeLink,
        width: 140,
        autoHeight: true,
        cellStyle: {'white-space': 'normal'},
        valueGetter: this.getTaskType,
      },
      {
        headerName: 'Due Date',
        field: 'taskDueDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatDates,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        width: 125,
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButton,
        cellStyle: {'text-align': 'center !important'},
        width: 100,
        suppressFilter: true,
        suppressSorting: true,
      },
    ];

    this.columnDefs = [
      {
        headerName: 'Announcements',
        field: 'title',
        cellStyle: {'white-space': 'normal'},
      },
      {
        headerName: 'Date',
        field: 'effectiveToDt',
        filter: "agDateColumnFilter",
        width: 90,
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        }
      },
      {
        headerName: 'Priority',
        field: "priorityCd",
        width: 80,
        refData: this.prioritiesJson,
        cellStyle: {'white-space': 'normal'},
        valueGetter: this.getPriorityType
      }
    ];

    this.tabToNextCell = function tabToNextCell(params) {
      var nextCell = params.nextCellDef;
      if (nextCell.column.colDef.headerName === "Action" || nextCell.column.colDef.headerName === "Task ID" || nextCell.column.colDef.headerName === "Task Type") {
        return;
      }
      else {
        return nextCell;
      }
    };

    this.context = {
      component: this,
    };
  }

  getAuditColumnDefs() {
    this.auditColumnDefs = [
      {
        headerName: 'Task ID',
        field: 'id',
        tooltipField: 'id'
      },
      {
        headerName: 'Task Type',
        field: 'taskType',
        refData: this.taskTypesJson,
        tooltip: (params) => {
          const taskTypesMap = params.context.taskTypesJson;
          const taskTypeCode = params.data.taskType;
          const taskType = taskTypesMap[taskTypeCode];
          return taskType;
        }
      },
      {
        headerName: 'Task Status',
        field: 'taskStatus',
        refData: this.taskStatusJson,
        tooltip: (params) => {
          const taskStatusMap = params.context.taskStatusJson;
          const taskStatusCode = params.data.taskStatus;
          const taskStatus = taskStatusMap[taskStatusCode];
          return taskStatus;
        }
      },
      {
        headerName: 'Modified By',
        field: 'createdBy',
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'lastModifiedDate',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        tooltip: this.agGridUtility.formatTimeDateToDateTime
      }
    ];

  }

  onGridReady(params) {
    this.gridApi = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onAnnouncementsGridReady(params) {
    this.gridAnnouncementsApi = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  getPriorityType(params){
    const that = params.context.component;
    let priorityType = that.convertCode(that.prioritiesMap, params.data.priorityCd);
    if( params.data.priorityCd == undefined){
      priorityType = "";
    }
    return priorityType;
  }

  getTaskType(params){
    const task: Task = params.data;
    const that = params.context.component;
    return that.taskTypesMap.get(task.taskType);
  }

  getTaskIdLink(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    element.innerHTML = params.data.id;
    element.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.TasksEntity');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Task History');
      that.getUserInfoForTaskId(params.data, params.data.wpReferral.id, params.data.wpPerson.id);
      // Pass Floating Elements here...
      // that.dataService.addValueToSharedDataMap('floatingData', that.auditElements);
    });

    // START ADA
    element.addEventListener('keydown', (event) => {
      if(event.keyCode === 13 || event.keyCode === 32){
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.TasksEntity');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Task History');
        that.getUserInfoForTaskId(params.data, params.data.wpReferral.id, params.data.wpPerson.id);
      }
      else{
        return;
      }
    });
    element.setAttribute("tabindex", "0");
    // END ADA

    return element;
  }

  getTaskTypeLink(params) {
    const that = params.context.component;
    const taskTypeName = that.convertCode(that.taskTypesMap, params.data.taskType);
    if(params.data.taskStatus === 'CO'){
      return taskTypeName;
    } else {
      const element = document.createElement('a');
      element.innerHTML = taskTypeName;
      element.addEventListener('click', () => {
        that.routeSelection(params.data, params.data.wpReferral.id, params.data.wpPerson.id);
      });
      return element;
    }
  }

  getEditButton(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    const image = EDIT_BTN;

    //element.className = 'edit-button';
    element.innerHTML = image;
    element.addEventListener('click', () => {
      //that.setInitSearchCriteria();
      that.dataService.addValueToSharedDataMap('referralId', params.data.wpReferral.id);
      that.dataService.addValueToSharedDataMap('wpPersonId', params.data.wpPerson.id);
      that.dataService.addValueToSharedDataMap('task', params.data);
      that.router.navigate(['/task/createTask']);
    });

    // START ADA
    element.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.dataService.addValueToSharedDataMap('referralId', params.data.wpReferral.id);
        that.dataService.addValueToSharedDataMap('wpPersonId', params.data.wpPerson.id);
        that.dataService.addValueToSharedDataMap('task', params.data);
        that.router.navigate(['/task/createTask']);
      }
      else {
        return;
      }
    });
   /* element.setAttribute("tabindex", "0");*/
    // END ADA
    return element;
  }


  getUserInfoForTaskId(task, referralId, wpPersonId){
    this.dataService.addValueToSharedDataMap('referralId', referralId);
    this.dataService.addValueToSharedDataMap('wpPersonId', wpPersonId);
    this.http.post<any>(this.ServerConstants.COMMON_SERVER_API_URL + "/personsummary/personEnrollmentSummary",
      { "referralId": Number(referralId), "personId": Number(wpPersonId) })
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res === null || res === undefined) {
            this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
          } else {
            const personEnrollmentSummary: any = res;

            if (personEnrollmentSummary.etEnrrolment !== null) {
              if (personEnrollmentSummary.etEnrollment.enrollmentEndDt != null) {
                this.dataService.makeAllPagesReadyIfCaseClosed();
              } else {
                this.dataService.revertReadOnlyChanges();
                this.dataService.addValueToSharedDataMap('IS_CASE_CLOSE_READ_ONLY', false);
              }
              this.dataService.addValueToSharedDataMap("etEnrollment", personEnrollmentSummary.etEnrollment);
            }
            if (personEnrollmentSummary.personProvider !== null) {
              this.dataService.addValueToSharedDataMap("personProvider", personEnrollmentSummary.personProvider);
            }

            this.router.navigate(['/task/taskSummary/auditHistory']);
          }
        },
        response => {
          this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }
  routeSelection(task, referralId, wpPersonId) {
      //this.setInitSearchCriteria();
      this.dataService.addValueToSharedDataMap('referralId', referralId);
      this.dataService.addValueToSharedDataMap('wpPersonId', wpPersonId);
      console.log('worker.dashboard.component - routeSelection - task.taskType ========== '+task.taskType);
      if(task.taskType==="RR") {

        this.http.post<WpPerson>(this.ServerConstants.COMMON_SERVER_API_URL + '/persondata/load', wpPersonId ).subscribe(
          (data: WpPerson ) => {
            if(data!==undefined && data.ssn!==undefined)
            {
              this.dataService.addValueToSharedDataMap('SSN_SEARCH',data.ssn);
              this.dataService.addValueToSharedDataMap('UNIVERSE_SEARCH',true);
              this.navigateRoute(task);
            }

          },response => {
            //Display Toast Error Notification
            this.notificationService.error('Person', this.userActionNotificationsMap.ERROR);
          },() => {
          })


      } 
      else{
        this.http.post<any>(this.ServerConstants.COMMON_SERVER_API_URL + "/personsummary/personEnrollmentSummary",
          { "referralId": Number(referralId), "personId": Number(wpPersonId) })
          .subscribe(
            (res: HttpResponse<any>) => {
              if (res === null || res === undefined) {
                this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
              } else {
                const personEnrollmentSummary: any = res;

                if (personEnrollmentSummary.etEnrrolment !== null) {
                  if (personEnrollmentSummary.etEnrollment.enrollmentEndDt != null) {
                    this.dataService.makeAllPagesReadyIfCaseClosed();
                  } else {
                    this.dataService.revertReadOnlyChanges();
                    this.dataService.addValueToSharedDataMap('IS_CASE_CLOSE_READ_ONLY', false);
                  }
                  this.dataService.addValueToSharedDataMap("etEnrollment", personEnrollmentSummary.etEnrollment);
                }
                if (personEnrollmentSummary.personProvider !== null) {
                  this.dataService.addValueToSharedDataMap("personProvider", personEnrollmentSummary.personProvider);
                }


                this.navigateRoute(task);


              }
            },
            response => {
              this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
            },
            () => {
            });
      }
    }

    navigateRoute(task) {
      switch (task.taskType) {
        case 'RF': {  // Referral
          this.router.navigate(['task/contactSummary']);
          break;
        }
        case 'AP': {  // Referral
          this.dataService.addValueToSharedDataMap('appTaskId', task.id);
          this.router.navigate(['/task/appointment']);
          break;
        }
        case 'CA': {  // Referral
          this.router.navigate(['/task/appointment']);
          break;
        }
        case 'PA': {  // Perform Assessment
          this.router.navigate(['task/assessmentSummary']);
          break;
        }
        case 'CN':  // Client Not Longer RTW
        case 'CC':  // Case Closure
        case 'CD':  // Client Dropped from SNAP Case
        case 'ER':  // Employment Plan Annual Review
        case 'EP': {  // Employment Plan
          this.dataService.addValueToSharedDataMap('taskId', task.id);
          this.router.navigate(['task/employmentPlanSummary']);
          break;
        }
        case 'CM':  // Component
        case 'CU': {  // Component Updates
          this.router.navigate(['task/componentSummary']);
          break;
        }
        case 'MT': {  // Monthly Track Component
          this.router.navigate(['task/componentSummary/trackComponent']);
  
          break;
        }
        case 'PR': {  // Provider Reassigment
          this.router.navigate(['task/personSummary/enrollmentSummary']);
          break;
        }
        case 'CE':
        case 'CG':
        case 'GQ':
        case 'DG':
        case 'NC':  // Non Compliance
        case 'GR':  // Good Cause Request
        case 'GD': {  // Good Cause Decision
          this.router.navigate(['/task/noncomplianceSummary']);
          break;
        }
        case 'ED': {  // Exemption Decision
          this.router.navigate(['/task/noncomplianceSummary']);
          break;
        }
        case 'PR': {  // Provider Reassignment
          this.router.navigate(['task/personSummary']);
          break;
        }
        case 'DU':{
          this.router.navigate(['task/correspondence']);
          break;
        }
        case 'AC':  // Address Change
        case 'WR':  // Work Registration Exemption
        case 'ND':  // Non Compliance Decision
        case 'EX':  // Exemption Request
        case 'AR':  // Activity Recommendation
        case 'RR': {  // Reverse Referral
          this.dataService.addValueToSharedDataMap('task', task);
          this.router.navigate(['/universe/create']);
          break;
        }
        case 'ET':
        case 'OT':
        case 'OS': {  // Reverse Referral
          this.dataService.addValueToSharedDataMap('task', task);
          this.router.navigate(['/task/createTask']);
          break;
        }
        case 'RQ':  // Reimbursement Request
        case 'RE':  //  Reimbursement Return for Revision (Actionable)
        case 'OP': {
          this.router.navigate(['/task/reimbursementsSummary/reimbursements']);
          break;
        }
        case 'RP':  //  Reimbursement Paid (Informational)
        case 'RA': {  //  Reimbursement Decision
          this.router.navigate(['/task/reimbursementsSummary']);
          break;
        }
        case 'RR': {  // Reverse Referral
          this.router.navigate(['/universe/personSummary']);
          break;
        }
        case 'EC': {  // Employment Change
          this.router.navigate(['task/assessmentSummary']);
          break;
        }
        case 'TC': {  // Contact Change
          this.router.navigate(['task/personSummary']);
          break;
        }
      }
    }


  updateTaskDataChart(pending, upcoming, overdue , labels,count){
    let maxValueP = Math.max.apply(Math, pending);
    let maxValueU = Math.max.apply(Math, upcoming);
    let maxValueO = Math.max.apply(Math, overdue);

    let maxValue = Math.max( maxValueP, maxValueU, maxValueO  );
    maxValue = Math.ceil((maxValue+1) / 10) * 10;
    this.noPendingTasks = pending.reduce((a, b) => a + b, 0);
    this.noUpcomingTasks = upcoming.reduce((a, b) => a + b, 0);
    //this.noOverdueTasks = overdue.reduce((a, b) => a + b, 0);
    if(count != null){
      this.noOverdueTasks = 0;
      count.forEach((element)=>{
        this.noOverdueTasks += element.ycount;
      })
    }
    this.chartTaskOptions.scales.yAxes[0].ticks.max = maxValue;
    this.chartTaskOptions.scales.yAxes[0].ticks.stepSize = maxValue/5;
    this.chartTaskData[0].data = pending;
    this.chartTaskData[1].data = upcoming;
    this.chartTaskData[2].data = overdue;
    this.chartTaskLabels = labels;
  }

  goToTaskList(){
    this.goToTaskSearch(this.dashboardSearchRequest.taskChart.todayDate , this.dashboardSearchRequest.taskChart.todayDate,
      null, 'OP', null, 'N');
  }


  goToTaskSearch(fromDate, toDate, taskType, taskStatus, county, completionDtSw) {


    console.log('wp goToTaskSearch: fromDate, toDate, taskType, taskStatus, county, completionDtSw: ' + fromDate + ', ' + toDate+ ', ' +  taskType+ ', ' +  taskStatus+ ', ' +  county+ ', ' +  completionDtSw);
    
    if(fromDate == null && toDate != null) {
      //Overdue Link
      this.dataService.addValueToSharedDataMap('overdueTasks', true);
      console.log('Dashboard overdue flag: ' + this.dataService.getSharedDataObject().get('overdueTasks'));
    }

    this.dataService.addValueToSharedDataMap('initTaskSearchSw', 'Y');
    if (fromDate != null) {
      fromDate = this.dateUtil.formatDate(fromDate);
      fromDate = this.dateUtil.convertDateFromServer(fromDate);
    }

    if (toDate != null) {
      toDate = this.dateUtil.formatDate(toDate);
      toDate = this.dateUtil.convertDateFromServer(toDate);
    }

    if (county === undefined || county === '-1' || county === -1) {
      county = null;
    }

    //console.log(fromDate, toDate, taskType, taskStatus, county)
    this.dataService.addValueToSharedDataMap('taskDueDateFrom', fromDate);
    this.dataService.addValueToSharedDataMap('taskDueDateTo', toDate);
    this.dataService.addValueToSharedDataMap('taskType', taskType);
    this.dataService.addValueToSharedDataMap('programCd', null);
    this.dataService.addValueToSharedDataMap('taskStatus', taskStatus);
    this.dataService.addValueToSharedDataMap('searchCriteria', 'all');
    this.dataService.addValueToSharedDataMap('currentSearch', null);
    this.dataService.addValueToSharedDataMap('assignedTo', null);
    this.dataService.addValueToSharedDataMap('county', county);
    this.dataService.addValueToSharedDataMap('completionDtSw', completionDtSw);
    this.router.navigate(['/task']);
  }

  goToAnnouncements(){
    this.router.navigate(['/task/announcementsSummary']);
  }

  goToTask(){
    this.router.navigate(['/task']);
  }


  onChartClick($event){

  }

  convertCode(myMap, code){
    if(myMap != undefined){
      return myMap.get(code);
    }
  }

  parseRefTableData() {
    this.taskStatus = this.data.getValueFromSharedDataMap("TASKSTATUS");
    this.priorities = this.data.getValueFromSharedDataMap("PRIORITY");
    this.taskTypes = this.data.getValueFromSharedDataMap('TASKTYPES');

    this.taskStatusMap = this.commonUtil.createMapFromList(this.taskStatus);
    this.prioritiesMap = this.commonUtil.createMapFromList(this.priorities);
    this.taskTypesMap = this.commonUtil.createMapFromList(this.taskTypes);

    this.prioritiesJson = this.commonUtil.createNativeMapFromList(this.priorities);
    this.taskTypesJson = this.commonUtil.createNativeMapFromList(this.taskTypes);
    this.taskStatusJson = this.commonUtil.createNativeMapFromList(this.taskStatus);
    this.countyCds = this.data.getValueFromSharedDataMap('COUNTIES');
    this.countyMap = this.commonUtil.createMapFromList(this.countyCds);
    this.countyMap.set("-1", "All Counties");

    //this.taskType = this.data.getValueFromSharedDataMap('TASKTYPES');
    this.taskTypeMap = this.commonUtil.createMapFromList(this.taskType);

    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
  }

  focusAnnouncementSummary(e) {
    this.addEventListenerAnnouncements(e);
  }

  addEventListenerAnnouncements(event){
    var tabKeyCode = 9;
    var spaceKeyCode = 32;
    var enterKeycode = 13;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode && event.keyCode !== spaceKeyCode && event.keyCode !== enterKeycode  ) {
      return;
    }

    if(this.dashboardSearchResponse.announcements.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    }
    else if( event.keyCode  === enterKeycode || event.keyCode == spaceKeyCode){
      this.goToAnnouncements();
    }
    else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setAnnouncementsDisplayedRowAtIndex();
  }


  setAnnouncementsDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridAnnouncementsApi.getFirstDisplayedRow();
    var rowNode =  this.gridAnnouncementsApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridAnnouncementsApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridAnnouncementsApi.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridAnnouncementsApi.setFocusedCell(index, firstCol);
  }


  focusing(event){
    if(!event.shiftKey && event.keyCode==9){
      let logoElements = document.getElementsByClassName('jh-logo-container');
      if(logoElements && logoElements.length > 0){
        (logoElements[0] as HTMLDivElement).setAttribute('tabIndex', Number(0).toString());
        (logoElements[0] as HTMLDivElement).focus();
      }
      return true;
    }
  }

  loadProviders() {

    this.providerService.findAllProvidersList().subscribe(
      (res: any) => {
        const providersLst: WpProvider[] = res;
        this.searchWorkerDashboard();
        if (providersLst !== undefined && providersLst !== null && providersLst.length !== 0) {
          const providers = new Map<any, string>();
          for (const p of providersLst) {
            providers.set(p.id, p.providerName);
          }
          this.dataService.addValueToSharedDataMap('providers', providers);
        }
      }, (res: HttpErrorResponse) => {
        this.notificationService.error('Providers', this.userActionNotificationsMap.ERROR);
      }, () => {
      }
    );
  }
}




// WEBPACK FOOTER //
// ./src/app/worker-dashboard/worker-dashboard.component.ts